// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { getNumberOfUnits } from '../../common/utils/baggageUtils';
export const getNumberOfUnitsCabinBaggage = (name, form) => state => getNumberOfUnits(name, form)(state);
//# sourceMappingURL=units.js.map